import * as R from 'ramda'
import { takeUntil } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import * as Actions from 'store/actions/index.ts'

export const disableTracking = R.curry((
  types,
  actions$
) => (
  takeUntil(
    types && types.length
      ? actions$.pipe(ofType(...types))
      : actions$.pipe(ofType(Actions.tracking.DISABLE_ALL_TRACKING))
  )
))

export const disableFacebookTracking = (actions$) => (
  disableTracking([
    Actions.tracking.DISABLE_ALL_TRACKING,
    Actions.tracking.DISABLE_FACEBOOK_TRACKING
  ], actions$)
)

export const disableGoogleTracking = (actions$) => (
  disableTracking([
    Actions.tracking.DISABLE_ALL_TRACKING,
    Actions.tracking.DISABLE_GOOGLE_TRACKING
  ], actions$)
)

export const disableMixPanelTracking = (actions$) => (
  disableTracking([
    Actions.tracking.DISABLE_ALL_TRACKING,
    Actions.tracking.DISABLE_MIXPANEL_TRACKING
  ], actions$)
)
